// ---------------------------------------------------------------------------
// Valley Tickets - District Demo Configuration
// ---------------------------------------------------------------------------
// This file is the SINGLE SOURCE OF TRUTH for the district showcase system.
// To add a new district demo: add a new object to the DISTRICTS array below.
// No new components or routes are required - the demo pages render entirely
// from this configuration.
//
// IMPORTANT: The school lists, mascots, and colors below are best-effort sample
// data for demo purposes. VERIFY each district's real schools / mascots /
// brand colors before presenting the demo to that district.
//
// Field reference (per district):
//   slug            unique URL segment, e.g. "edinburg-cisd"  -> /demo/edinburg-cisd
//   name            full district name
//   shortName       abbreviation used in compact UI
//   city            primary city / area
//   tagline         one-line marketing line shown in the hero
//   colors          { primary, secondary, accent } hex values (used as inline styles)
//   logo            optional path under /public, e.g. "/images/districts/edinburg-cisd.png"
//   highSchools     [{ name, mascot, colors?: [hex,...] }]
//   middleSchools   [{ name, mascot? }]
//   athleticEvents  [{ title, sport, home, away?, date, time, venue, price }]
//   fineArtsEvents  [{ title, type, school, date, time, venue, price }]
// ---------------------------------------------------------------------------

export const DISTRICTS = [
  {
    slug: "edinburg-cisd",
    name: "Edinburg CISD",
    shortName: "ECISD",
    city: "Edinburg, TX",
    tagline: "One home for every Bobcat, Cougar, SaberCat & Jaguar ticket.",
    colors: { primary: "#0b2c5e", secondary: "#1d4ed8", accent: "#f5b301" },
    logo: "https://www.ecisd.us/pics/header_logo.png",
    highSchools: [
      { name: "Edinburg High School", mascot: "Bobcats", logo: "https://edinburg.ecisd.us/pics/mascot_logo.png" },
      { name: "Edinburg North High School", mascot: "Cougars", logo: "https://edinburgnorth.ecisd.us/pics/mascot_logo.png" },
      { name: "Robert Vela High School", mascot: "SaberCats", logo: "https://vela.ecisd.us/pics/mascot_logo.png" },
      { name: "J. Economedes High School", mascot: "Jaguars", logo: "https://economedes.ecisd.us/pics/mascot_logo.png" },
      { name: "Edinburg Collegiate High School", mascot: "Lynx", logo: "https://chs.ecisd.us/pics/header_logo.png" },
    ],
    middleSchools: [
      { name: "Barrientes Middle School", mascot: "Bearcats", logo: "https://barrientes.ecisd.us/pics/mascot_logo.png" },
      { name: "B.L. Garza Middle School", mascot: "Tigers", logo: "https://blgarza.ecisd.us/pics/mascot_logo.png" },
      { name: "Brewster School", mascot: "Longhorns", logo: "https://brewster.ecisd.us/pics/mascot_logo.png" },
      { name: "Harwell Middle School", mascot: "Lions", logo: "https://harwell.ecisd.us/pics/mascot_logo.png" },
      { name: "Longoria Middle School", mascot: "Panthers", logo: "https://longoria.ecisd.us/pics/mascot_logo.png" },
      { name: "Memorial Middle School", mascot: "Wildcats", logo: "https://memorial.ecisd.us/pics/mascot_logo.png" },
      { name: "South Middle School", mascot: "Rebcats", logo: "https://south.ecisd.us/pics/mascot_logo.png" },
      { name: "Vision Academy of Excellence", mascot: "Vikings", logo: "https://vision.ecisd.us/pics/mascot_logo.png" },
    ],
    athleticEvents: [
      { title: "Bi-District Football", sport: "Football", home: "Edinburg High", away: "McAllen Memorial", date: "2026-09-11", time: "7:30 PM", venue: "Richard R. Flores Stadium", price: "$8" },
      { title: "District Volleyball", sport: "Volleyball", home: "Edinburg North", away: "Robert Vela", date: "2026-09-15", time: "6:00 PM", venue: "ENHS Gymnasium", price: "$5" },
      { title: "Varsity Basketball", sport: "Basketball", home: "Economedes", away: "Edinburg High", date: "2026-11-20", time: "7:00 PM", venue: "Economedes Gymnasium", price: "$6" },
    ],
    fineArtsEvents: [
      { title: "Fall Marching Showcase", type: "Band", school: "Edinburg High", date: "2026-10-03", time: "7:00 PM", venue: "Richard R. Flores Stadium", price: "$7" },
      { title: "Winter Choir Concert", type: "Choir", school: "Robert Vela", date: "2026-12-10", time: "6:30 PM", venue: "Vela Auditorium", price: "$5" },
      { title: "One-Act Play Festival", type: "Theatre", school: "Edinburg North", date: "2026-11-14", time: "6:00 PM", venue: "ENHS Auditorium", price: "$5" },
    ],
  },

  {
    slug: "mcallen-isd",
    name: "McAllen ISD",
    shortName: "MISD",
    city: "McAllen, TX",
    tagline: "Bulldogs, Mustangs & Warriors - all your tickets in one place.",
    colors: { primary: "#003b71", secondary: "#0a57a4", accent: "#fdb913" },
    logo: "/images/districts/mcallen-district.png",
    highSchools: [
      { name: "McAllen High School", mascot: "Bulldogs", logo: "/images/districts/mcallen-bulldogs.png" },
      { name: "McAllen Memorial High School", mascot: "Mustangs", logo: "/images/districts/mcallen-memorial-mustangs.png" },
      { name: "James \"Nikki\" Rowe High School", mascot: "Warriors", logo: "/images/districts/mcallen-rowe-warriors.png" },
    ],
    middleSchools: [
      { name: "Dorothea Brown Middle School", mascot: "Dobermans" },
      { name: "Dr. Rodney D. Cathey Middle School", mascot: "Cobras" },
      { name: "Alonzo De Leon Middle School", mascot: "Lions" },
      { name: "Michael E. Fossum Middle School", mascot: "Falcons" },
      { name: "Homer J. Morris Middle School", mascot: "Stallions" },
      { name: "William B. Travis Middle School", mascot: "Terriers" },
    ],
    athleticEvents: [
      { title: "Cross-Town Football", sport: "Football", home: "McAllen High", away: "McAllen Memorial", date: "2026-09-18", time: "7:30 PM", venue: "McAllen Veterans Memorial Stadium", price: "$8" },
      { title: "District Soccer", sport: "Soccer", home: "Rowe", away: "McAllen High", date: "2026-01-23", time: "7:15 PM", venue: "Rowe Soccer Field", price: "$5" },
      { title: "Varsity Basketball", sport: "Basketball", home: "McAllen Memorial", away: "Rowe", date: "2026-12-04", time: "7:00 PM", venue: "Memorial Gymnasium", price: "$6" },
    ],
    fineArtsEvents: [
      { title: "Mariachi Festival", type: "Mariachi", school: "McAllen High", date: "2026-10-17", time: "6:30 PM", venue: "MHS Performing Arts Center", price: "$8" },
      { title: "Orchestra Winter Concert", type: "Orchestra", school: "McAllen Memorial", date: "2026-12-12", time: "7:00 PM", venue: "Memorial Auditorium", price: "$5" },
      { title: "Spring Theatre Production", type: "Theatre", school: "Rowe", date: "2026-04-24", time: "7:00 PM", venue: "Rowe Auditorium", price: "$7" },
    ],
  },

  {
    slug: "psja-isd",
    name: "PSJA ISD",
    shortName: "PSJA",
    city: "Pharr-San Juan-Alamo, TX",
    tagline: "Bears, Raiders, Wolverines & Javelinas - game day made simple.",
    colors: { primary: "#800000", secondary: "#a52a2a", accent: "#c1121f" },
    logo: "/images/districts/psja-district.png",
    highSchools: [
      { name: "PSJA High School", mascot: "Bears", logo: "/images/districts/psja-bears.png" },
      { name: "PSJA North High School", mascot: "Raiders", logo: "/images/districts/psja-north-raiders.png" },
      { name: "PSJA Memorial High School", mascot: "Wolverines", logo: "/images/districts/psja-memorial-wolverines.png" },
      { name: "PSJA Southwest High School", mascot: "Javelinas", logo: "/images/districts/psja-southwest-javelinas.png" },
    ],
    middleSchools: [
      { name: "Alamo Middle School" },
      { name: "Audie Murphy Middle School" },
      { name: "Jaime Escalante Middle School" },
      { name: "Kennedy Middle School" },
      { name: "Liberty Middle School" },
      { name: "LBJ Middle School" },
      { name: "Raul Yzaguirre Middle School" },
      { name: "Stephen F. Austin Middle School" },
    ],
    athleticEvents: [
      { title: "District Football", sport: "Football", home: "PSJA High", away: "PSJA North", date: "2026-09-25", time: "7:30 PM", venue: "PSJA Stadium", price: "$8" },
      { title: "Varsity Volleyball", sport: "Volleyball", home: "PSJA Memorial", away: "PSJA Southwest", date: "2026-09-29", time: "6:00 PM", venue: "Memorial Gymnasium", price: "$5" },
      { title: "Boys Basketball", sport: "Basketball", home: "PSJA North", away: "PSJA High", date: "2026-12-09", time: "7:00 PM", venue: "North Gymnasium", price: "$6" },
    ],
    fineArtsEvents: [
      { title: "Marching Band Showcase", type: "Band", school: "PSJA High", date: "2026-10-10", time: "7:00 PM", venue: "PSJA Stadium", price: "$7" },
      { title: "Folklórico Spring Show", type: "Dance", school: "PSJA Southwest", date: "2026-05-01", time: "6:30 PM", venue: "Southwest Auditorium", price: "$6" },
      { title: "Choir Holiday Concert", type: "Choir", school: "PSJA Memorial", date: "2026-12-15", time: "6:30 PM", venue: "Memorial Auditorium", price: "$5" },
    ],
  },

  {
    slug: "mission-cisd",
    name: "Mission CISD",
    shortName: "MCISD",
    city: "Mission, TX",
    tagline: "Eagles & Patriots - one portal for every Mission event.",
    colors: { primary: "#7a0019", secondary: "#b3122b", accent: "#0a2342" },
    logo: "/images/districts/mission-district.svg",
    highSchools: [
      { name: "Mission High School", mascot: "Eagles" },
      { name: "Veterans Memorial High School", mascot: "Patriots", logo: "/images/districts/mission-vmhs-patriots.jpg" },
    ],
    middleSchools: [
      { name: "Rafael Cantu Jr. High" },
      { name: "Mission Jr. High" },
      { name: "Kenneth White Jr. High" },
      { name: "Alton Memorial Jr. High" },
    ],
    athleticEvents: [
      { title: "City Championship Football", sport: "Football", home: "Mission High", away: "Veterans Memorial", date: "2026-10-02", time: "7:30 PM", venue: "Tom Landry Stadium", price: "$8" },
      { title: "District Volleyball", sport: "Volleyball", home: "Veterans Memorial", away: "Mission High", date: "2026-09-22", time: "6:00 PM", venue: "VMHS Gymnasium", price: "$5" },
      { title: "Varsity Basketball", sport: "Basketball", home: "Mission High", away: "Veterans Memorial", date: "2026-12-11", time: "7:00 PM", venue: "Mission Gymnasium", price: "$6" },
    ],
    fineArtsEvents: [
      { title: "Fall Band Concert", type: "Band", school: "Mission High", date: "2026-10-20", time: "7:00 PM", venue: "MHS Auditorium", price: "$6" },
      { title: "Winter Choir Showcase", type: "Choir", school: "Veterans Memorial", date: "2026-12-08", time: "6:30 PM", venue: "VMHS Auditorium", price: "$5" },
      { title: "Spring One-Act Play", type: "Theatre", school: "Mission High", date: "2026-03-27", time: "7:00 PM", venue: "MHS Auditorium", price: "$5" },
    ],
  },

  {
    slug: "sharyland-isd",
    name: "Sharyland ISD",
    shortName: "SISD",
    city: "Mission, TX",
    tagline: "Rattlers & Diamondbacks - strike up game day with Valley Tickets.",
    colors: { primary: "#c8102e", secondary: "#8a0b20", accent: "#6b7280" },
    logo: "https://resources.finalsite.net/images/f_auto,q_auto/v1751539647/sharylandisdorg/pi2rjydrc0k5omclzylz/SharylandISDPrimaryLogoImage.png",
    highSchools: [
      { name: "Sharyland High School", mascot: "Rattlers", logo: "/images/districts/sharyland-rattlers.png" },
      { name: "Sharyland Pioneer High School", mascot: "Diamondbacks", logo: "/images/districts/sharyland-pioneer-diamondbacks.png" },
    ],
    middleSchools: [
      { name: "B.L. Gray Junior High", mascot: "Rattlers" },
      { name: "Sharyland North Junior High" },
    ],
    athleticEvents: [
      { title: "District Football", sport: "Football", home: "Sharyland High", away: "Sharyland Pioneer", date: "2026-10-09", time: "7:30 PM", venue: "Richard Thompson Stadium", price: "$8" },
      { title: "Varsity Volleyball", sport: "Volleyball", home: "Sharyland Pioneer", away: "Sharyland High", date: "2026-09-26", time: "6:00 PM", venue: "Pioneer Gymnasium", price: "$5" },
      { title: "Varsity Soccer", sport: "Soccer", home: "Sharyland High", away: "Mission High", date: "2026-01-30", time: "7:15 PM", venue: "Sharyland Soccer Complex", price: "$5" },
    ],
    fineArtsEvents: [
      { title: "Marching Band Festival", type: "Band", school: "Sharyland High", date: "2026-10-24", time: "7:00 PM", venue: "Richard Thompson Stadium", price: "$7" },
      { title: "Orchestra Winter Concert", type: "Orchestra", school: "Sharyland Pioneer", date: "2026-12-09", time: "7:00 PM", venue: "Pioneer Auditorium", price: "$5" },
      { title: "Theatre Spring Musical", type: "Theatre", school: "Sharyland High", date: "2026-04-17", time: "7:00 PM", venue: "SHS Auditorium", price: "$8" },
    ],
  },

  {
    slug: "weslaco-isd",
    name: "Weslaco ISD",
    shortName: "WISD",
    city: "Weslaco, TX",
    tagline: "Panthers & Wildcats - every Weslaco event, one tap away.",
    colors: { primary: "#3f1f69", secondary: "#5b2d8c", accent: "#7c3aed" },
    logo: "/images/districts/weslaco-district.png",
    highSchools: [
      { name: "Weslaco High School", mascot: "Panthers", logo: "/images/districts/weslaco-panthers.png" },
      { name: "Weslaco East High School", mascot: "Wildcats", logo: "/images/districts/weslaco-east-wildcats.png" },
    ],
    middleSchools: [
      { name: "Central Middle School" },
      { name: "Beatriz G. Garza Middle School" },
      { name: "Armando Cuellar Middle School" },
      { name: "Mary Hoge Middle School" },
    ],
    athleticEvents: [
      { title: "City Championship Football", sport: "Football", home: "Weslaco High", away: "Weslaco East", date: "2026-10-16", time: "7:30 PM", venue: "Bobby Lackey Stadium", price: "$8" },
      { title: "District Volleyball", sport: "Volleyball", home: "Weslaco East", away: "Weslaco High", date: "2026-09-30", time: "6:00 PM", venue: "East Gymnasium", price: "$5" },
      { title: "Varsity Basketball", sport: "Basketball", home: "Weslaco High", away: "Weslaco East", date: "2026-12-16", time: "7:00 PM", venue: "Weslaco Gymnasium", price: "$6" },
    ],
    fineArtsEvents: [
      { title: "Fall Band Showcase", type: "Band", school: "Weslaco High", date: "2026-10-27", time: "7:00 PM", venue: "Bobby Lackey Stadium", price: "$7" },
      { title: "Winter Choir Concert", type: "Choir", school: "Weslaco East", date: "2026-12-11", time: "6:30 PM", venue: "East Auditorium", price: "$5" },
      { title: "Spring Theatre Production", type: "Theatre", school: "Weslaco High", date: "2026-04-10", time: "7:00 PM", venue: "WHS Auditorium", price: "$6" },
    ],
  },

  {
    slug: "donna-isd",
    name: "Donna ISD",
    shortName: "DISD",
    city: "Donna, TX",
    tagline: "Redskins & Chiefs - Donna pride, ticketed in seconds.",
    colors: { primary: "#7a1f2b", secondary: "#5a0f1a", accent: "#c8a951" },
    logo: "/images/districts/donna-district.png",
    highSchools: [
      { name: "Donna High School", mascot: "Redskins", logo: "/images/districts/donna-redskins.png" },
      { name: "Donna North High School", mascot: "Chiefs", logo: "/images/districts/donna-north-chiefs.png" },
    ],
    middleSchools: [
      { name: "A.P. Solis Middle School" },
      { name: "D.M. Sauceda Middle School" },
      { name: "Veterans Middle School" },
      { name: "W.A. Todd Middle School" },
    ],
    athleticEvents: [
      { title: "City Championship Football", sport: "Football", home: "Donna High", away: "Donna North", date: "2026-10-23", time: "7:30 PM", venue: "Bennie La Prade Stadium", price: "$8" },
      { title: "District Volleyball", sport: "Volleyball", home: "Donna North", away: "Donna High", date: "2026-10-06", time: "6:00 PM", venue: "Donna North Gymnasium", price: "$5" },
      { title: "Varsity Basketball", sport: "Basketball", home: "Donna High", away: "Donna North", date: "2026-12-18", time: "7:00 PM", venue: "Donna Gymnasium", price: "$6" },
    ],
    fineArtsEvents: [
      { title: "Marching Band Showcase", type: "Band", school: "Donna High", date: "2026-10-30", time: "7:00 PM", venue: "Bennie La Prade Stadium", price: "$7" },
      { title: "Winter Choir Concert", type: "Choir", school: "Donna North", date: "2026-12-12", time: "6:30 PM", venue: "Donna North Auditorium", price: "$5" },
      { title: "Spring One-Act Play", type: "Theatre", school: "Donna High", date: "2026-03-20", time: "7:00 PM", venue: "DHS Auditorium", price: "$5" },
    ],
  },

  {
    slug: "la-joya-isd",
    name: "La Joya ISD",
    shortName: "LJISD",
    city: "La Joya, TX",
    tagline: "Coyotes, Huskies & Lobos - the whole pack in one app.",
    colors: { primary: "#c8102e", secondary: "#7a0a1c", accent: "#111111" },
    logo: "/images/districts/lajoya-district.png",
    highSchools: [
      { name: "La Joya High School", mascot: "Coyotes", logo: "/images/districts/lajoya-coyotes.png" },
      { name: "Palmview High School", mascot: "Lobos", logo: "/images/districts/lajoya-palmview-lobos.png" },
      { name: "Juarez-Lincoln High School", mascot: "Huskies", logo: "/images/districts/lajoya-juarez-lincoln-huskies.png" },
    ],
    middleSchools: [
      { name: "Ann Richards Middle School" },
      { name: "Cesar E. Chavez Middle School" },
      { name: "Lorenzo De Zavala Middle School" },
      { name: "Irene M. Garcia Middle School" },
      { name: "Memorial Middle School" },
      { name: "Dr. Javier Saenz Middle School" },
      { name: "Juan De Dios Salinas Middle School" },
      { name: "Domingo Trevino Middle School" },
    ],
    athleticEvents: [
      { title: "District Football", sport: "Football", home: "La Joya High", away: "Palmview", date: "2026-10-30", time: "7:30 PM", venue: "La Joya ISD Stadium", price: "$8" },
      { title: "Varsity Volleyball", sport: "Volleyball", home: "Juarez-Lincoln", away: "La Joya High", date: "2026-10-07", time: "6:00 PM", venue: "Juarez-Lincoln Gymnasium", price: "$5" },
      { title: "Boys Basketball", sport: "Basketball", home: "Palmview", away: "Juarez-Lincoln", date: "2026-12-19", time: "7:00 PM", venue: "Palmview Gymnasium", price: "$6" },
    ],
    fineArtsEvents: [
      { title: "Mariachi Showcase", type: "Mariachi", school: "La Joya High", date: "2026-11-07", time: "6:30 PM", venue: "La Joya ISD PAC", price: "$8" },
      { title: "Winter Band Concert", type: "Band", school: "Palmview", date: "2026-12-13", time: "7:00 PM", venue: "Palmview Auditorium", price: "$5" },
      { title: "Spring Theatre Production", type: "Theatre", school: "Juarez-Lincoln", date: "2026-04-18", time: "7:00 PM", venue: "Juarez-Lincoln Auditorium", price: "$6" },
    ],
  },

  {
    slug: "valley-view-isd",
    name: "Valley View ISD",
    shortName: "VVISD",
    city: "Pharr, TX",
    tagline: "Tigers territory - Valley View tickets, simplified.",
    colors: { primary: "#003da5", secondary: "#0a57c4", accent: "#ffc72c" },
    logo: "https://cmsv2-assets.apptegy.net/uploads/11089/logo/12528/Valley_View_ISD_logo_template_300.png",
    highSchools: [
      { name: "Valley View High School", mascot: "Tigers", logo: "https://image.maxpreps.io/school-mascot/4/d/c/4dc9e75d-4dbc-473a-aedf-378e141a29fc.gif" },
    ],
    middleSchools: [
      { name: "Valley View Junior High School", mascot: "Tigers" },
    ],
    athleticEvents: [
      { title: "District Football", sport: "Football", home: "Valley View High", away: "Hidalgo High", date: "2026-11-06", time: "7:30 PM", venue: "Tiger Stadium", price: "$7" },
      { title: "Varsity Volleyball", sport: "Volleyball", home: "Valley View High", away: "PSJA Southwest", date: "2026-10-08", time: "6:00 PM", venue: "Valley View Gymnasium", price: "$5" },
      { title: "Varsity Basketball", sport: "Basketball", home: "Valley View High", away: "Hidalgo High", date: "2026-12-20", time: "7:00 PM", venue: "Valley View Gymnasium", price: "$6" },
    ],
    fineArtsEvents: [
      { title: "Fall Band Concert", type: "Band", school: "Valley View High", date: "2026-11-10", time: "7:00 PM", venue: "VVHS Auditorium", price: "$5" },
      { title: "Winter Choir Showcase", type: "Choir", school: "Valley View High", date: "2026-12-14", time: "6:30 PM", venue: "VVHS Auditorium", price: "$5" },
      { title: "Spring One-Act Play", type: "Theatre", school: "Valley View High", date: "2026-03-28", time: "7:00 PM", venue: "VVHS Auditorium", price: "$5" },
    ],
  },

  {
    slug: "hidalgo-isd",
    name: "Hidalgo ISD",
    shortName: "HISD",
    city: "Hidalgo, TX",
    tagline: "Pirates pride - set sail with Valley Tickets.",
    colors: { primary: "#1b2a4a", secondary: "#2a3f6b", accent: "#c7a24b" },
    logo: "https://www.hidalgo-isd.org/pics/school_logo.png",
    highSchools: [
      { name: "Hidalgo Early College High School", mascot: "Pirates", logo: "https://hechs.hidalgo-isd.org/pics/school_logo.png" },
    ],
    middleSchools: [
      { name: "Ida Diaz Junior High School", logo: "https://diaz.hidalgo-isd.org/pics/school_logo.png" },
    ],
    athleticEvents: [
      { title: "District Football", sport: "Football", home: "Hidalgo High", away: "Valley View High", date: "2026-11-13", time: "7:30 PM", venue: "Pirate Stadium", price: "$7" },
      { title: "Varsity Volleyball", sport: "Volleyball", home: "Hidalgo High", away: "Edcouch-Elsa High", date: "2026-10-09", time: "6:00 PM", venue: "Hidalgo Gymnasium", price: "$5" },
      { title: "Varsity Basketball", sport: "Basketball", home: "Hidalgo High", away: "Valley View High", date: "2027-01-08", time: "7:00 PM", venue: "Hidalgo Gymnasium", price: "$6" },
    ],
    fineArtsEvents: [
      { title: "Fall Band Showcase", type: "Band", school: "Hidalgo High", date: "2026-11-17", time: "7:00 PM", venue: "Pirate Stadium", price: "$5" },
      { title: "Winter Choir Concert", type: "Choir", school: "Hidalgo High", date: "2026-12-16", time: "6:30 PM", venue: "Hidalgo Auditorium", price: "$5" },
      { title: "Spring Theatre Production", type: "Theatre", school: "Hidalgo High", date: "2026-04-11", time: "7:00 PM", venue: "Hidalgo Auditorium", price: "$5" },
    ],
  },

  {
    slug: "edcouch-elsa-isd",
    name: "Edcouch-Elsa ISD",
    shortName: "EEISD",
    city: "Edcouch, TX",
    tagline: "Yellowjackets - buzz into game day with Valley Tickets.",
    colors: { primary: "#1a1a1a", secondary: "#3a3a3a", accent: "#ffc72c" },
    logo: "/images/districts/edcouch-elsa-district.png",
    highSchools: [
      { name: "Edcouch-Elsa High School", mascot: "Yellowjackets" },
    ],
    middleSchools: [
      { name: "Carlos F. Truan Junior High School" },
      { name: "P.F.C. David Ybarra Middle School" },
    ],
    athleticEvents: [
      { title: "District Football", sport: "Football", home: "Edcouch-Elsa High", away: "Hidalgo High", date: "2026-11-20", time: "7:30 PM", venue: "Yellowjacket Stadium", price: "$7" },
      { title: "Varsity Volleyball", sport: "Volleyball", home: "Edcouch-Elsa High", away: "La Villa High", date: "2026-10-10", time: "6:00 PM", venue: "E-E Gymnasium", price: "$5" },
      { title: "Varsity Basketball", sport: "Basketball", home: "Edcouch-Elsa High", away: "Hidalgo High", date: "2027-01-09", time: "7:00 PM", venue: "E-E Gymnasium", price: "$6" },
    ],
    fineArtsEvents: [
      { title: "Marching Band Showcase", type: "Band", school: "Edcouch-Elsa High", date: "2026-11-24", time: "7:00 PM", venue: "Yellowjacket Stadium", price: "$5" },
      { title: "Winter Choir Concert", type: "Choir", school: "Edcouch-Elsa High", date: "2026-12-17", time: "6:30 PM", venue: "E-E Auditorium", price: "$5" },
      { title: "Spring One-Act Play", type: "Theatre", school: "Edcouch-Elsa High", date: "2026-04-04", time: "7:00 PM", venue: "E-E Auditorium", price: "$5" },
    ],
  },
];

// Lookup helper used by the district demo page.
export const getDistrictBySlug = (slug) =>
  DISTRICTS.find((d) => d.slug === slug) || null;

// ---------------------------------------------------------------------------
// Sample analytics (attendance + revenue)
// ---------------------------------------------------------------------------
// These are DERIVED deterministically from each district's slug + school count
// so the numbers are stable across renders and realistic in scale - and so new
// districts added to DISTRICTS automatically get demo analytics with no extra
// config. A district may override any of these by adding a `stats` object.

// Deterministic seeded PRNG (mulberry32) keyed off the slug.
const seedFrom = (str) => {
  let h = 1779033703 ^ str.length;
  for (let i = 0; i < str.length; i++) {
    h = Math.imul(h ^ str.charCodeAt(i), 3432918353);
    h = (h << 13) | (h >>> 19);
  }
  return h >>> 0;
};
const makeRng = (seed) => {
  let a = seed;
  return () => {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
};

const MONTHS = ['Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];

export const getDistrictStats = (district) => {
  if (district.stats) return district.stats;

  const rng = makeRng(seedFrom(district.slug));
  const schoolCount =
    (district.highSchools?.length || 0) + (district.middleSchools?.length || 0);
  const scale = Math.max(1, schoolCount);

  const ticketsToday = Math.round(180 + rng() * 90 * scale);
  const avgPrice = 6 + rng() * 2; // ~$6-8 avg
  const revenueToday = Math.round(ticketsToday * avgPrice);

  const ticketsYTD = Math.round((9000 + rng() * 4000) * scale);
  const revenueYTD = Math.round(ticketsYTD * avgPrice);

  const avgAttendance = Math.round(420 + rng() * 380);
  const activeSchools = Math.min(schoolCount, Math.max(1, Math.round(schoolCount * (0.5 + rng() * 0.4))));
  const eventsThisWeek = Math.max(2, Math.round(rng() * 4 + scale));

  // 7-point attendance trend (in thousands of fans), gently rising.
  let base = 2.2 + rng() * 1.5;
  const attendanceTrend = MONTHS.map((m) => {
    base += (rng() - 0.35) * 0.9;
    base = Math.max(1.2, base);
    return { month: m, fans: Math.round(base * 1000) };
  });

  // Revenue split across categories (sums to revenueYTD).
  const athShare = 0.55 + rng() * 0.12;
  const faShare = 0.2 + rng() * 0.1;
  const athletics = Math.round(revenueYTD * athShare);
  const fineArts = Math.round(revenueYTD * faShare);
  const community = revenueYTD - athletics - fineArts;
  const revenueByCategory = [
    { name: 'Athletics', value: athletics },
    { name: 'Fine Arts', value: fineArts },
    { name: 'Community', value: community },
  ];

  return {
    ticketsToday,
    revenueToday,
    ticketsYTD,
    revenueYTD,
    avgAttendance,
    activeSchools,
    schoolCount,
    eventsThisWeek,
    attendanceTrend,
    revenueByCategory,
  };
};

// Currency / number formatters reused across demo + dashboard.
export const fmtUSD = (n) =>
  n >= 1000 ? `$${(n / 1000).toFixed(n >= 100000 ? 0 : 1)}k` : `$${n}`;
export const fmtUSDFull = (n) =>
  `$${Math.round(n).toLocaleString('en-US')}`;
export const fmtNum = (n) => n.toLocaleString('en-US');

export default DISTRICTS;
